module.exports = __webpack_public_path__ + "img/compact.68bc80e6.png";